import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import BalanceRoundedIcon from "@mui/icons-material/BalanceRounded";
import {
  Autocomplete,
  Box,
  Chip,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Avatar,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
// import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import * as XLSX from "xlsx";
import { decode } from "base-64";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

const PieGuyAssociation = ({ associations, title_data }) => {
  if (!associations || associations.length === 0) {
    return <p>No data available</p>;
  }
  const config = {
    options: {
      title: {
        text: `${title_data} accounts Performance`,
        align: "left",
        style: {
          color: "#444",
          fontFamily:
            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        },
      },
      labels: associations?.map((item) => item.association_name),
    },
    series: associations?.map((item) => item.current_balance),
    responsive: [
      {
        breakpoint: 880,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <Chart
      options={config.options}
      series={config.series}
      type="pie"
      height={390}
      width={390}
    />
  );
};
const SegmentationDonut = ({
  data,
  setSege,
  setSege_data,
  sege_who,
  setSege_who,
}) => {
  if (!data || Object.keys(data).length === 0) {
    return (
      <Typography
        variant="subtitle"
        sx={{ textAlign: "center" }}
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
      >
        <b>No Data Available</b>
      </Typography>
    );
  }

  const consistentSavers = data["ConsistentSaver"];
  const regularSavers = data["RegularSaver"];
  const infrequentSavers = data["InfrequentSaver"];
  const dormantSavers = data["DormantSavers"];

  const config = {
    options: {
      labels: [
        "Active Savers",
        "Regular Savers",
        "Low Active Savers",
        "Dormant Savers",
      ],
      legend: {
        position: "bottom",
      },
      chart: {
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const selectedDataPointIndex =
              config.w.globals.selectedDataPoints[0];
            const segment = config.w.config.labels[selectedDataPointIndex[0]];
            if (segment === "Active Savers") {
              if (sege_who === "Active Savers") {
                setSege(false);
                setSege_data([]);
                setSege_who("");
              } else {
                setSege(true);
                setSege_data(consistentSavers);
                setSege_who("Active Savers");
              }
            } else if (segment === "Regular Savers") {
              if (sege_who === "Regular Savers") {
                setSege(false);
                setSege_data([]);
                setSege_who("");
              } else {
                setSege(true);
                setSege_data(regularSavers);
                setSege_who("Regular Savers");
              }
            } else if (segment === "Infrequent Savers") {
              if (sege_who === "Infrequent Savers") {
                setSege(false);
                setSege_data([]);
                setSege_who("");
              } else {
                setSege(true);
                setSege_data(infrequentSavers);
                setSege_who("Infrequent Savers");
              }
            } else if (segment === "Dormant Savers") {
              if (sege_who === "Dormant Savers") {
                setSege(false);
                setSege_data([]);
                setSege_who("");
              } else {
                setSege(true);
                setSege_data(dormantSavers);
                setSege_who("Dormant Savers");
              }
            }
          },
        },
      },
    },
    series: [
      consistentSavers.Customers.length,
      regularSavers.Customers.length,
      infrequentSavers.Customers.length,
      dormantSavers.Customers.length,
    ],
    responsive: [
      {
        breakpoint: 880,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <Chart
      options={config.options}
      series={config.series}
      type="donut"
      height={300}
      width={200}
    />
  );
};
const SegmentationDonutCash = ({
  data,
  setSege,
  setSege_data,
  sege_who,
  setSege_who,
}) => {
  if (!data || Object.keys(data).length === 0) {
    return (
      <Typography
        variant="subtitle"
        sx={{ textAlign: "center" }}
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
      >
        <b>No Data Available</b>
      </Typography>
    );
  }

  const consistentSavers = data["HighSavers"];
  const regularSavers = data["MediumSavers"];
  const infrequentSavers = data["LowSavers"];

  const config = {
    options: {
      labels: ["High Savers", "Medium Savers", "Low Savers"],
      legend: {
        position: "bottom",
      },
      chart: {
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const selectedDataPointIndex =
              config.w.globals.selectedDataPoints[0];
            const segment = config.w.config.labels[selectedDataPointIndex[0]];
            if (segment === "High Savers") {
              if (sege_who === "High Savers") {
                setSege(false);
                setSege_data([]);
                setSege_who("");
              } else {
                setSege(true);
                setSege_data(consistentSavers);
                setSege_who("High Savers");
              }
            } else if (segment === "Medium Savers") {
              if (sege_who === "Medium Savers") {
                setSege(false);
                setSege_data([]);
                setSege_who("");
              } else {
                setSege(true);
                setSege_data(regularSavers);
                setSege_who("Medium Savers");
              }
            } else if (segment === "Low Savers") {
              if (sege_who === "Low Savers") {
                setSege(false);
                setSege_data([]);
                setSege_who("");
              } else {
                setSege(true);
                setSege_data(infrequentSavers);
                setSege_who("Low Savers");
              }
            }
          },
        },
      },
    },
    series: [
      consistentSavers.Customers.length,
      regularSavers.Customers.length,
      infrequentSavers.Customers.length,
    ],
    responsive: [
      {
        breakpoint: 880,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <Chart
      options={config.options}
      series={config.series}
      type="donut"
      height={300}
      width={200}
    />
  );
};

const BarGuyAssociation = ({ associations, title_data }) => {
  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const config = {
    series: [
      {
        name: "Balances",
        data: associations?.map((item) => item.current_balance),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: associations?.map((item) => item.association_name),
      },
      yaxis: {
        title: {
          text: "Balances",
        },
        labels: {
          show: true,
          formatter: function (val) {
            return currencyFormat.format(val);
          },
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return currencyFormat.format(val);
          },
        },
      },
      title: {
        text: `${title_data} accounts Performance(savings groups)`,
        style: {
          color: "#444",
          fontFamily:
            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        },
      },
    },
  };

  return (
    <Chart
      options={config.options}
      series={config.series}
      type="bar"
      height={330}
    />
  );
};

const SegmentBars = ({ data, title_data }) => {
  if (!data || Object.keys(data).length === 0) {
    return (
      <Typography
        variant="subtitle"
        sx={{ textAlign: "center" }}
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
      >
        <b>No Data Available</b>
      </Typography>
    );
  }

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const consistentSavers = data.ConsistentSaver;
  const regularSavers = data.RegularSaver;
  const infrequentSavers = data.InfrequentSaver;
  const dormantSavers = data.DormantSavers;

  const config = {
    series: [
      {
        name: "Active Savers",
        data: Object.values(consistentSavers),
      },
      {
        name: "Regular Savers",
        data: Object.values(regularSavers),
      },
      {
        name: "Low Active Savers",
        data: Object.values(infrequentSavers),
      },
      {
        name: "Dormant Savers",
        data: Object.values(dormantSavers),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          ...new Set([
            ...Object.keys(consistentSavers),
            ...Object.keys(regularSavers),
            ...Object.keys(infrequentSavers),
            ...Object.keys(dormantSavers),
          ]),
        ],
      },
      yaxis: {
        title: {
          text: "Number of Members",
        },
        labels: {
          show: true,
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      title: {
        text: `${title_data}`,
        style: {
          color: "#444",
          fontFamily:
            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        },
      },
    },
  };

  return (
    <Chart
      options={config.options}
      series={config.series}
      type="bar"
      height={350}
    />
  );
};
const SegmentBarsDep = ({ data, title_data }) => {
  if (!data || Object.keys(data).length === 0) {
    return (
      <Typography
        variant="subtitle"
        sx={{ textAlign: "center" }}
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
      >
        <b>No Data Available</b>
      </Typography>
    );
  }

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const consistentSavers = data.HighSavers;
  const regularSavers = data.MediumSavers;
  const infrequentSavers = data.LowSavers;

  const config = {
    series: [
      {
        name: "High Savers",
        data: Object.values(consistentSavers),
      },
      {
        name: "Medium Savers",
        data: Object.values(regularSavers),
      },
      {
        name: "Low Savers",
        data: Object.values(infrequentSavers),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          ...new Set([
            ...Object.keys(consistentSavers),
            ...Object.keys(regularSavers),
            ...Object.keys(infrequentSavers),
          ]),
        ],
      },
      yaxis: {
        title: {
          text: "Number of Members",
        },
        labels: {
          show: true,
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      title: {
        text: `${title_data}`,
        style: {
          color: "#444",
          fontFamily:
            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        },
      },
    },
  };

  return (
    <Chart
      options={config.options}
      series={config.series}
      type="bar"
      height={350}
    />
  );
};

const AreaManSavings = ({ title_data, data, time }) => {
  if (!data || data.length === 0) {
    return (
      <Typography
        variant="h5"
        sx={{ textAlign: "center" }}
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
      >
        <b>No Data Available</b>
      </Typography>
    );
  }

  const config = {
    series: [
      {
        name: "Savings",
        data: data.map((item) => item?.amount),
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "String",
        categories: data?.map((item) => item?.date),
        range: 10,
      },
      title: {
        text: `${title_data} ${time} Performance View`,
        style: {
          color: "#444",
          fontFamily:
            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        },
      },
    },
  };

  return (
    <Chart
      options={config.options}
      series={config.series}
      type="area"
      height={350}
    />
  );
};

const LineManTrendsData = ({ title_data, data }) => {
  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  if (!data || data.length === 0) {
    return (
      <Typography
        variant="h4"
        sx={{ textAlign: "center" }}
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
      >
        <b>No Data Available</b>
      </Typography>
    );
  }

  const config = {
    series: [
      {
        name: "Deposits Change (%)",
        data: data.map((item) =>
          item?.deposit_change !== null && item?.deposit_change !== undefined
            ? item.deposit_change
            : 0
        ),
      },
      {
        name: "Withdrawals Change (%)",
        data: data.map((item) =>
          item?.withdrawal_change !== null &&
          item?.withdrawal_change !== undefined
            ? item.withdrawal_change
            : 0
        ),
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "String",
        categories: data?.map((item) =>
          formatDateToYearMonthDay(new Date(item.date))
        ),
        range: 10,
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return `${value.toFixed(2)}%`;
          },
        },
      },
      title: {
        text: `${title_data}`,
        style: {
          color: "#444",
          fontFamily:
            "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        },
      },
    },
  };

  return (
    <Chart
      options={config.options}
      series={config.series}
      type="area"
      height={400}
    />
  );
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Ittem = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

export const DashSavings = ({ society_id, account_id, name, clo }) => {
  const [members, setMembers] = useState([]);
  const [society, setSociety] = useState([]);
  const [details, setDetails] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [associations, setAssociations] = useState([]);
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState();
  const [value, setValue] = useState("1");
  const [value1, setValue1] = useState(0);
  const [data, setData] = useState([]);
  const [periodic_state, setPeriodicState] = useState("Weekly");
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [clusters, setClusters] = useState([]);
  const [selected_cluster, setSelected_cluster] = useState({});
  const [who, setWho] = useState(
    typeof name === "string" && name.includes("Society" || "society")
      ? name
      : `${name ? name : ""} Society`
  );
  const [selected_com, setSelected_com] = useState({});
  const [groups, setGroups] = useState([]);
  const [selected_group, setSelected_group] = useState({});
  const [tester, setTester] = useState([]);
  const [forecast_period, setForecast_period] = useState(7);
  const [account_data, setAccount_data] = useState([]);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [sege, setSege] = useState(false);
  const [sege_data, setSege_data] = useState([]);
  const [sege_who, setSege_who] = useState("");
  const [sege_level, setSege_level] = useState("Clusters");
  const [associationCount, setAssociationCount] = useState(0);
  const [clusterCount, setClusterCount] = useState(0);
  const [communityCount, setCommunityCount] = useState(0);

  useEffect(() => {
    if (!sege_data || Object.keys(sege_data).length === 0) {
      setAssociationCount(0);
      setClusterCount(0);
      setCommunityCount(0);
    } else {
      const associations = new Set(
        sege_data.Customers.map((row) => row.Savings_Group)
      );
      const clusters = new Set(sege_data.Customers.map((row) => row.Cluster));
      const communities = new Set(
        sege_data.Customers.map((row) => row.Community)
      );

      setAssociationCount(associations.size);
      setClusterCount(clusters.size);
      setCommunityCount(communities.size);
    }
  }, [sege_data]);

  const visitAssociations = (association_id) => {
    api
      .get(`/association/${association_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        navigate("/association/", { state: { responseData: response.data } });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const pic = (pic) => {
    if (!pic) return null;
    const de = atob(pic);
    return `data:image/jpeg;base64,${de}`;
  };

  const handlePsb = (id, name) => {
    navigate("/onemember/", {
      state: {
        Member_id: id,
        Fullname: name,
      },
    });
  };

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (clo) {
      setSelected_cluster({});
      setSelected_com({});
      setSelected_group({});
      setSege(false);
      setSege_data([]);
      setSege_who("");
    }
    setWho(
      typeof name === "string" && name.includes("Society" || "society")
        ? name
        : `${name ? name : ""} Society`
    );
  }, [society_id]);

  const accounte = () => {
    api
      .get(`/account/one/savings/${account_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAccount_data(response.data?.Account_Details);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    accounte();
  }, [account_id]);

  const fetch_groups = () => {
    const storedGroups = localStorage.getItem(`groups_${selected_com?.id}`);

    if (storedGroups) {
      setGroups(JSON.parse(storedGroups));
    } else {
      api
        .get(`/association/get/groups/in/communities/${selected_com?.id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setGroups(response.data?.groups);
          localStorage.setItem(
            `groups_${selected_com?.id}`,
            JSON.stringify(response.data?.groups)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    if (selected_com?.id) {
      fetch_groups();
    }
  }, [selected_com, account_id]);

  const fetch_communities = () => {
    const storedComm = localStorage.getItem(
      `communitiess_${selected_cluster?.id}`
    );

    if (storedComm) {
      setCommunities(JSON.parse(storedComm));
    } else {
      api
        .get(
          `/association/get/communities/in/cluster/${selected_cluster?.id}`,
          {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }
        )
        .then(function (response) {
          setCommunities(response.data?.communities);
          localStorage.setItem(
            `communitiess_${selected_cluster?.id}`,
            JSON.stringify(response.data?.communities)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    if (selected_cluster?.id) {
      fetch_communities();
    }
  }, [selected_cluster, account_id]);

  const fetch_clusters = () => {
    const storedClusters = localStorage.getItem(`clusters_${society_id}`);
    if (storedClusters) {
      setClusters(JSON.parse(storedClusters));
    } else {
      api
        .get(`/association/get/clusters/${society_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setClusters(response.data?.all);
          localStorage.setItem(
            `clusters_${society_id}`,
            JSON.stringify(response.data?.all)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    fetch_clusters();
  }, [society_id, account_id]);

  useEffect(() => {
    fetch_data();
  }, [society_id, account_id]);

  const exportToExcel = () => {
    const title = `${who} ${periodic_state} ${account_data?.account_name} Report (GHS)`;
    const headers = [
      "Date",
      "Cash Deposits",
      "Cash Withdrawals",
      "Cash Balance (dep - wit)",
    ];

    // Prepare data with header rows
    const datta =
      tester &&
      tester?.transactions_amount
        ?.filter(
          (row) =>
            row.date !== 0 ||
            row.deposit_amount !== 0 ||
            row.withdrawal_amount !== 0 ||
            row.balance_amount !== 0
        )
        .map((row) => [
          formatDateToYearMonthDay(new Date(row.date)),
          row.deposit_amount,
          row.withdrawal_amount,
          row.balance_amount,
        ]);

    // Combine title, headers, and data into worksheet
    const worksheetData = [[title], [], headers, ...datta];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Merge title row cells
    XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: "A1" });
    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
    ];

    // Style title row (optional)
    worksheet["A1"].s = {
      font: { bold: true, sz: 16 },
      alignment: { vertical: "center", horizontal: "center" },
    };

    // Create workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Export to Excel
    XLSX.writeFile(workbook, "SavingsAccountCashFlow.xlsx");
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const getInitials = (crop) => {
    const firstInitial = crop ? crop.charAt(0).toUpperCase() : "";
    const lastInitial = crop ? crop.charAt(1).toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const fetch_data_first = () => {
    // const cacheKey = `fetch_data_${society_id}_${periodic_state}_${start_date}_${end_date}_${selected_cluster?.id}_${selected_com?.id}_${selected_group?.id}`;

    const data = new FormData();
    data.append("society_id", society_id);
    data.append("periodic_state", periodic_state);
    data.append("start_date", start_date);
    data.append("account_id", account_id);
    data.append("end_date", end_date);
    data.append("forecast_period", forecast_period);
    data.append("cluster_id", selected_cluster?.id ? selected_cluster.id : 0);
    data.append("community_id", selected_com?.id ? selected_com.id : 0);
    data.append("group_id", selected_group?.id ? selected_group.id : 0);

    // const cachedData = localStorage.getItem(cacheKey);

    // if (!isOnline) {
    //   const parsedData = JSON.parse(cachedData);
    //   setTester(parsedData);
    // } else {
    toast.promise(
      api.post("/dashboards/analytics/one/savings/account/w", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading...",
        success: (response) => {
          setTester(response.data);
          // localStorage.setItem(cacheKey, JSON.stringify(response.data));
          // console.log(response.data)
          return "Done";
        },
        error: (error) => {
          console.log(error);

          return "An Error Occurred, Please try again";
        },
      }
    );
    // }
  };

  useEffect(() => {
    fetch_data_first();
  }, [
    account_id,
    society_id,
    periodic_state,
    start_date,
    end_date,
    selected_cluster,
    selected_com,
    selected_group,
  ]);

  const fetch_data = () => {
    const data = new FormData();
    data.append("society_id", society_id);
    data.append("account_id", account_id);

    api
      .get(`/dashboards/details/for/society/dash/${society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMembers(response.data?.data[0]);
        setSociety(response.data?.society);
        setCommunities(response.data?.communities);
        setAssociations(response.data?.associations);
        setWarehouses(response.data?.warehouses);
      })
      .catch(function (error) {
        console.log(error);
      });
    // allowed
    api
      .get("/users/user/society", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAllowed(response.data?.Soc);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .post("/dashboards/analytics/one/savings/account", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setDetails(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch_data();
  }, [society_id, account_id]);

  if (society_id) {
    return (
      <Grid item xs={12} md={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Ittem>
              <Typography
                sx={{ textAlign: "center" }}
                variant="h4"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>{account_data?.account_name} Table Filters</b>
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "block" }}>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: "flex", flexDirection: "column", my: 1 }}>
                  <Typography
                    sx={{ mr: 1 }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>From</b>
                  </Typography>
                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    name="start_date"
                    onChange={(e) => setStart_date(e.target.value)}
                    value={start_date}
                    sx={{ mr: 1 }}
                  />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", my: 1 }}>
                  <Typography
                    sx={{ mr: 1 }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>To</b>
                  </Typography>
                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    name="end_date"
                    onChange={(e) => setEnd_date(e.target.value)}
                    value={end_date}
                    sx={{ mr: 1 }}
                  />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", my: 1 }}>
                  <Typography
                    variant="h6"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      Date:{" "}
                      {start_date
                        ? formatDateToYearMonthDay(new Date(start_date))
                        : "Default"}
                      {"  "} - {"  "}{" "}
                      {end_date
                        ? formatDateToYearMonthDay(new Date(end_date))
                        : "Default"}
                    </b>
                  </Typography>
                </Box>
                <Divider variant="middle" />
                <Box sx={{ display: "flex", flexDirection: "column", my: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "#344e41" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b style={{ display: "flex", flexDirection: "row" }}>
                      Cluster:
                      {selected_cluster?.cluster
                        ? selected_cluster?.cluster
                        : "Not Filtered"}
                    </b>

                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={clusters}
                      // multiple
                      fullWidth
                      sx={{ mt: 0.5 }}
                      getOptionLabel={(option) => option.cluster_name}
                      isOptionEqualToValue={(option, value) =>
                        option.cluster_id === value.cluster_id
                      }
                      onChange={(event, value) => {
                        setSelected_cluster({
                          id: value.cluster_id,
                          cluster: value.cluster_name,
                        });
                        setWho(value.cluster_name);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          size="small"
                          placeholder="Select Cluster"
                        />
                      )}
                    />

                    {selected_cluster?.id && (
                      <Chip
                        size="small"
                        label={
                          <Typography
                            variant="subtitle"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                            <b>Clear</b>
                          </Typography>
                        }
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "#da1e37",
                          color: "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={() => {
                          setSelected_cluster({});
                          setSelected_com({});
                          setSelected_group({});
                        }}
                      />
                    )}
                  </Typography>
                </Box>
                <Divider variant="middle" />
                <Box sx={{ display: "flex", flexDirection: "column", my: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "#432818" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      Community:{" "}
                      {selected_com?.community
                        ? selected_com?.community
                        : "Not Filtered"}
                    </b>
                    {!selected_cluster?.id ? (
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>No Cluster Selected</b>
                      </Typography>
                    ) : (
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={communities}
                        // multiple
                        fullWidth
                        sx={{ mt: 0.5 }}
                        getOptionLabel={(option) => option.community_name}
                        isOptionEqualToValue={(option, value) =>
                          option.community_id === value.community_id
                        }
                        onChange={(event, value) => {
                          setSelected_com({
                            id: value.community_id,
                            community: value.community_name,
                          });
                          setWho(value.community_name);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            size="small"
                            placeholder="Select Community"
                          />
                        )}
                      />
                    )}

                    {selected_com?.id && (
                      <Chip
                        size="small"
                        label={
                          <Typography
                            variant="subtitle"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Clear</b>
                          </Typography>
                        }
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "#da1e37",
                          color: "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={() => {
                          setSelected_com({});
                          setSelected_group({});
                        }}
                      />
                    )}
                  </Typography>
                </Box>
                <Divider variant="middle" />
                <Box sx={{ display: "flex", flexDirection: "column", my: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "#432818" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      Savings Group:{" "}
                      {selected_group?.group
                        ? selected_group?.group
                        : "Not Filtered"}
                      {selected_group?.id && (
                        <Chip
                          size="small"
                          label={
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Clear</b>
                            </Typography>
                          }
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            backgroundColor: "#da1e37",
                            color: "#fff",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={() => setSelected_group({})}
                        />
                      )}
                    </b>
                    {!selected_com?.id ? (
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>No Community Selected</b>
                      </Typography>
                    ) : (
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={groups}
                        // multiple
                        fullWidth
                        sx={{ mt: 0.5 }}
                        getOptionLabel={(option) => option.association_name}
                        isOptionEqualToValue={(option, value) =>
                          option.association_id === value.association_id
                        }
                        onChange={(event, value) => {
                          setSelected_group({
                            id: value.association_id,
                            group: value.association_name,
                          });
                          setWho(value.association_name);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            size="small"
                            placeholder="Select Group"
                          />
                        )}
                      />
                    )}
                  </Typography>
                </Box>
              </Box>
            </Ittem>
          </Grid>
          
          {account_id != 0 ? (
            <>
              <Grid item xs={12} md={12}>
                <Ittem>
                  <Typography
                    variant="h4"
                    sx={{ textAlign: "center" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>{account_data?.account_name} Table Analytics</b>
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                      <Ittem>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Average Metrics</b>
                        </Typography>
                        <Divider />
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Average Deposits:{" "}
                              <span style={{ color: "darkblue" }}>
                                {currencyFormat.format(
                                  tester?.average_metrics?.average_deposit
                                )}
                              </span>
                            </b>
                          </p>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Average Withdrawals:{" "}
                              <span style={{ color: "darkblue" }}>
                                {currencyFormat.format(
                                  tester?.average_metrics?.average_withdrawal
                                )}
                              </span>
                            </b>
                          </p>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Total No. of Members:{" "}
                              <span style={{ color: "darkblue" }}>
                                {
                                  tester?.customer_segments_big_money
                                    ?.unique_depositors
                                }
                              </span>
                            </b>
                          </p>
                        </Typography>
                      </Ittem>
                    </Grid>

                    <Grid item xs={12} md={2}>
                      <Ittem>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Accounts Segmentation</b>
                          </Typography>
                          <Typography
                            variant="caption"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Click on Segment for more Data</b>
                          </Typography>
                          <Divider />
                          <Box sx={{ mr: 2 }}>
                            <SegmentationDonut
                              data={
                                tester?.customer_segments?.customer_segments
                              }
                              setSege={setSege}
                              setSege_data={setSege_data}
                              sege_who={sege_who}
                              setSege_who={setSege_who}
                            />
                          </Box>
                        </Box>
                      </Ittem>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          View:
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Clusters</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Clusters" ? "filled" : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Clusters" ? "#fff" : "#2b2d42",
                              color:
                                sege_level === "Clusters" ? "#000" : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Clusters")}
                          />
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Communities</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Communities"
                                ? "filled"
                                : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Communities"
                                  ? "#fff"
                                  : "#2b2d42",
                              color:
                                sege_level === "Communities" ? "#000" : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Communities")}
                          />
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Saving Groups</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Saving Groups"
                                ? "filled"
                                : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Saving Groups"
                                  ? "#fff"
                                  : "#2b2d42",
                              color:
                                sege_level === "Saving Groups"
                                  ? "#000"
                                  : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Saving Groups")}
                          />
                        </b>
                      </Typography>
                      <SegmentBars
                        title_data={`${account_data?.account_name} ${sege_level} Accounts Segments`}
                        data={
                          sege_level === "Clusters"
                            ? tester?.customer_segments?.cluster_segments
                            : sege_level === "Communities"
                            ? tester?.customer_segments?.community_segments
                            : tester?.customer_segments?.association_segments
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={2}>
                          <Ittem>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>
                                  Accounts Segmentation (Based on Deposits
                                  Value)
                                </b>
                              </Typography>
                              <Typography
                                variant="caption"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Click on Segment for more Data</b>
                              </Typography>
                              <Divider />
                              <Box sx={{ mr: 2 }}>
                                <SegmentationDonutCash
                                  data={
                                    tester?.customer_segments_big_money
                                      ?.customer_segments
                                  }
                                  setSege={setSege}
                                  setSege_data={setSege_data}
                                  sege_who={sege_who}
                                  setSege_who={setSege_who}
                                />
                              </Box>
                            </Box>
                          </Ittem>
                        </Grid>

                        <Grid item xs={12} md={10}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              View:
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Clusters</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Clusters"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Clusters"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Clusters" ? "#000" : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Clusters")}
                              />
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Communities</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Communities"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Communities"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Communities"
                                      ? "#000"
                                      : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Communities")}
                              />
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Saving Groups</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Saving Groups"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Saving Groups"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Saving Groups"
                                      ? "#000"
                                      : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Saving Groups")}
                              />
                            </b>
                          </Typography>
                          <SegmentBarsDep
                            title_data={`${account_data?.account_name} ${sege_level} Accounts Segments (Deposits Value)`}
                            data={
                              sege_level === "Clusters"
                                ? tester?.customer_segments_big_money
                                    ?.cluster_segments
                                : sege_level === "Communities"
                                ? tester?.customer_segments_big_money
                                    ?.community_segments
                                : tester?.customer_segments_big_money
                                    ?.association_segments
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      {sege ? (
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            sx={{ display: "flex", flexDirection: "row" }}
                          >
                            <IconButton
                              sx={{ mr: "auto" }}
                              onClick={() => setSege(false)}
                            >
                              <ArrowBackRoundedIcon />
                            </IconButton>
                            <Typography
                              variant="h4"
                              sx={{ mr: "auto" }}
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>{sege_who}</b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Transaction: {sege_data?.Total_Deposits}{" "}
                                transactions
                              </b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Deposits:{" "}
                                {currencyFormat.format(
                                  sege_data?.Total_Savings
                                )}
                              </b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Members: {sege_data?.Customers.length}
                              </b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Saving Groups: {associationCount}</b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Communities: {communityCount}</b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Clusters: {clusterCount}</b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <Box
                              sx={{
                                overflowX: "auto",
                                maxHeight: 400,
                                overflowY: "auto",
                                "&::-webkit-scrollbar": {
                                  width: "7px",
                                  height: "7px",
                                },
                                "&::-webkit-scrollbar-track": {
                                  background: "#f1f1f1",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  background: "#888",
                                  borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                  background: "#555",
                                },
                              }}
                            >
                              <Table size="small" aria-label="a dense table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b></b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Passbook</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Member</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Frequency</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Transactions</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Deposits</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Group</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Community</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Cluster</b>
                                      </Typography>{" "}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {sege_data &&
                                    sege_data?.Customers?.map((row, index) => (
                                      <TableRow
                                        key={row.index}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                          backgroundColor: "#f5f3f4",
                                        }}
                                      >
                                        <TableCell align="left">
                                          <Avatar
                                            sx={{ width: 50, height: 50 }}
                                            src={pic(row.photo)}
                                            alt={row.Member_Name}
                                          />
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            onClick={() =>
                                              handlePsb(
                                                row.Member_id,
                                                row.Member_Name
                                              )
                                            }
                                            sx={{
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Passbook}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.Member_Name}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              {
                                                row.Average_Days_Between_Deposits
                                              }
                                            </b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.Total_Deposits}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              {currencyFormat.format(
                                                row.Total_Savings
                                              )}
                                            </b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            onClick={() =>
                                              visitAssociations(row.Group_id)
                                            }
                                            sx={{
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Savings_Group}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            // onClick={() => visitAssociations(row.Group_id)} sx={{ textDecoration:'underline', cursor:'pointer' }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Community}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            // onClick={() => visitAssociations(row.Group_id)} sx={{ textDecoration:'underline', cursor:'pointer' }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Cluster}</b>
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Grid>
                        </Grid>
                      ) : (
                        <LineManTrendsData
                          title_data={`${who
                            .split(" ")
                            .slice(0, 2)
                            .join(" ")} ${periodic_state} Trend Data`}
                          data={tester?.trend_data}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Ittem>
              </Grid>

              <Grid item xs={12} md={12}>
                <Ittem>
                  <Typography
                    variant="h4"
                    sx={{ textAlign: "center" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>{account_data?.account_name} Table</b>
                  </Typography>

                  <Box sx={{ my: 3 }}>
                    <Typography
                      sx={{ textAlign: "center" }}
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>
                        {who} {periodic_state} {account_data?.account_name}{" "}
                        Report{" "}
                        <Chip
                          size="small"
                          label={
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Export Table</b>
                            </Typography>
                          }
                          sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            backgroundColor: "#fff9ec",
                            color: "#000",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "darkblue",
                              color: "#fff",
                            },
                          }}
                          onClick={exportToExcel}
                        />
                      </b>
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Chip
                      label={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Weekly Report</b>
                        </Typography>
                      }
                      size="medium"
                      variant={
                        periodic_state === "Weekly" ? "filled" : "outlined"
                      }
                      sx={{
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor:
                          periodic_state === "Weekly" ? "#fff" : "#2b2d42",
                        color: periodic_state === "Weekly" ? "#000" : "#fff",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                          color: "#000",
                        },
                      }}
                      onClick={() => setPeriodicState("Weekly")}
                    />
                    <Chip
                      label={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Monthly Report</b>
                        </Typography>
                      }
                      size="medium"
                      variant={
                        periodic_state === "Monthly" ? "filled" : "outlined"
                      }
                      sx={{
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor:
                          periodic_state === "Monthly" ? "#fff" : "#2b2d42",
                        color: periodic_state === "Monthly" ? "#000" : "#fff",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                          color: "#000",
                        },
                      }}
                      onClick={() => setPeriodicState("Monthly")}
                    />
                    <Chip
                      label={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Quarterly Report</b>
                        </Typography>
                      }
                      size="medium"
                      variant={
                        periodic_state === "Quarterly" ? "filled" : "outlined"
                      }
                      sx={{
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor:
                          periodic_state === "Quarterly" ? "#fff" : "#2b2d42",
                        color: periodic_state === "Quarterly" ? "#000" : "#fff",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                          color: "#000",
                        },
                      }}
                      onClick={() => setPeriodicState("Quarterly")}
                    />
                    <Chip
                      label={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Yearly Report</b>
                        </Typography>
                      }
                      size="medium"
                      variant={
                        periodic_state === "Yearly" ? "filled" : "outlined"
                      }
                      sx={{
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor:
                          periodic_state === "Yearly" ? "#fff" : "#2b2d42",
                        color: periodic_state === "Yearly" ? "#000" : "#fff",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                          color: "#000",
                        },
                      }}
                      onClick={() => setPeriodicState("Yearly")}
                    />
                  </Box>
                  <Box
                    sx={{
                      overflowX: "auto",
                      maxHeight: 340,
                      overflowY: "auto",
                      "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Date</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Cash Deposits</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Cash Withdrawals</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Balance (cash deposits - cash withdrawals)</b>
                            </Typography>{" "}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tester &&
                          tester?.transactions_amount
                            ?.slice()
                            .reverse()
                            .map((row, index) => (
                              <TableRow
                                key={row.index}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                  backgroundColor: "#f5f3f4",
                                }}
                              >
                                <TableCell align="left">
                                  {row.date ===
                                    tester?.top_activity_days?.max_deposit_day
                                      ?.date ||
                                  row.date ===
                                    tester?.top_activity_days
                                      ?.max_withdrawal_day?.date ? (
                                    <Tooltip
                                      title={
                                        row.date ===
                                        tester?.top_activity_days
                                          ?.max_deposit_day?.date
                                          ? "Max Deposits Date"
                                          : "Max Withdrawals Date"
                                      }
                                    >
                                      <Typography
                                        sx={{
                                          color:
                                            row.date ===
                                              tester?.top_activity_days
                                                ?.max_deposit_day?.date ||
                                            row.date ===
                                              tester?.top_activity_days
                                                ?.max_withdrawal_day?.date
                                              ? "green"
                                              : "black",
                                        }}
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>
                                          {formatDateToYearMonthDay(
                                            new Date(row.date)
                                          )}
                                        </b>
                                      </Typography>
                                    </Tooltip>
                                  ) : (
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>
                                        {formatDateToYearMonthDay(
                                          new Date(row.date)
                                        )}
                                      </b>
                                    </Typography>
                                  )}
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <Box display="flex" alignItems="center">
                                      <b>
                                        {currencyFormat.format(
                                          row.deposit_amount
                                        )}
                                      </b>
                                      <span style={{ marginLeft: "8px" }}>
                                        {row.movement === "Up" ? (
                                          <ArrowUpwardRoundedIcon
                                            sx={{ color: "#007200" }}
                                          />
                                        ) : row.movement === "Down" ? (
                                          <ArrowDownwardRoundedIcon
                                            sx={{ color: "#ff0000" }}
                                          />
                                        ) : (
                                          <BalanceRoundedIcon
                                            sx={{ color: "#03045e" }}
                                          />
                                        )}
                                      </span>
                                    </Box>
                                    <Box
                                      sx={{
                                        color:
                                          row.movement === "Normal"
                                            ? "#03045e"
                                            : row.movement === "Up"
                                            ? "#007200"
                                            : "#ff0000",
                                      }}
                                    >
                                      <Typography
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        variant="caption"
                                        fontSize="0.8em"
                                      >
                                        <b>{row.performance}</b>
                                      </Typography>
                                    </Box>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <Box display="flex" alignItems="center">
                                      <b>
                                        {currencyFormat.format(
                                          row.withdrawal_amount
                                        )}
                                      </b>
                                    </Box>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {currencyFormat.format(
                                        row.balance_amount
                                      )}
                                    </b>
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Ittem>
              </Grid>

              <Grid item xs={12} md={12}>
                <Ittem>
                  <Typography
                    variant="h4"
                    sx={{ textAlign: "center" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>{account_data?.account_name} Table Analytics</b>
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                      <Ittem>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Average Metrics</b>
                        </Typography>
                        <Divider />
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Average Deposits:{" "}
                              <span style={{ color: "darkblue" }}>
                                {currencyFormat.format(
                                  tester?.average_metrics?.average_deposit
                                )}
                              </span>
                            </b>
                          </p>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Average Withdrawals:{" "}
                              <span style={{ color: "darkblue" }}>
                                {currencyFormat.format(
                                  tester?.average_metrics?.average_withdrawal
                                )}
                              </span>
                            </b>
                          </p>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Total No. of Members:{" "}
                              <span style={{ color: "darkblue" }}>
                                {
                                  tester?.customer_segments_big_money
                                    ?.unique_depositors
                                }
                              </span>
                            </b>
                          </p>
                        </Typography>
                      </Ittem>
                    </Grid>

                    <Grid item xs={12} md={2}>
                      <Ittem>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Accounts Segmentation</b>
                          </Typography>
                          <Typography
                            variant="caption"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Click on Segment for more Data</b>
                          </Typography>
                          <Divider />
                          <Box sx={{ mr: 2 }}>
                            <SegmentationDonut
                              data={
                                tester?.customer_segments?.customer_segments
                              }
                              setSege={setSege}
                              setSege_data={setSege_data}
                              sege_who={sege_who}
                              setSege_who={setSege_who}
                            />
                          </Box>
                        </Box>
                      </Ittem>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          View:
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Clusters</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Clusters" ? "filled" : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Clusters" ? "#fff" : "#2b2d42",
                              color:
                                sege_level === "Clusters" ? "#000" : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Clusters")}
                          />
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Communities</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Communities"
                                ? "filled"
                                : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Communities"
                                  ? "#fff"
                                  : "#2b2d42",
                              color:
                                sege_level === "Communities" ? "#000" : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Communities")}
                          />
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Saving Groups</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Saving Groups"
                                ? "filled"
                                : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Saving Groups"
                                  ? "#fff"
                                  : "#2b2d42",
                              color:
                                sege_level === "Saving Groups"
                                  ? "#000"
                                  : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Saving Groups")}
                          />
                        </b>
                      </Typography>
                      <SegmentBars
                        title_data={`${account_data?.account_name} ${sege_level} Accounts Segments`}
                        data={
                          sege_level === "Clusters"
                            ? tester?.customer_segments?.cluster_segments
                            : sege_level === "Communities"
                            ? tester?.customer_segments?.community_segments
                            : tester?.customer_segments?.association_segments
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={2}>
                          <Ittem>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>
                                  Accounts Segmentation (Based on Deposits
                                  Value)
                                </b>
                              </Typography>
                              <Typography
                                variant="caption"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Click on Segment for more Data</b>
                              </Typography>
                              <Divider />
                              <Box sx={{ mr: 2 }}>
                                <SegmentationDonutCash
                                  data={
                                    tester?.customer_segments_big_money
                                      ?.customer_segments
                                  }
                                  setSege={setSege}
                                  setSege_data={setSege_data}
                                  sege_who={sege_who}
                                  setSege_who={setSege_who}
                                />
                              </Box>
                            </Box>
                          </Ittem>
                        </Grid>

                        <Grid item xs={12} md={10}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              View:
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Clusters</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Clusters"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Clusters"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Clusters" ? "#000" : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Clusters")}
                              />
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Communities</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Communities"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Communities"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Communities"
                                      ? "#000"
                                      : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Communities")}
                              />
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Saving Groups</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Saving Groups"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Saving Groups"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Saving Groups"
                                      ? "#000"
                                      : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Saving Groups")}
                              />
                            </b>
                          </Typography>
                          <SegmentBarsDep
                            title_data={`${account_data?.account_name} ${sege_level} Accounts Segments (Deposits Value)`}
                            data={
                              sege_level === "Clusters"
                                ? tester?.customer_segments_big_money
                                    ?.cluster_segments
                                : sege_level === "Communities"
                                ? tester?.customer_segments_big_money
                                    ?.community_segments
                                : tester?.customer_segments_big_money
                                    ?.association_segments
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      {sege ? (
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            sx={{ display: "flex", flexDirection: "row" }}
                          >
                            <IconButton
                              sx={{ mr: "auto" }}
                              onClick={() => setSege(false)}
                            >
                              <ArrowBackRoundedIcon />
                            </IconButton>
                            <Typography
                              variant="h4"
                              sx={{ mr: "auto" }}
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>{sege_who}</b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Transaction: {sege_data?.Total_Deposits}{" "}
                                transactions
                              </b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Deposits:{" "}
                                {currencyFormat.format(
                                  sege_data?.Total_Savings
                                )}
                              </b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Members: {sege_data?.Customers.length}
                              </b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Saving Groups: {associationCount}</b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Communities: {communityCount}</b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Clusters: {clusterCount}</b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <Box
                              sx={{
                                overflowX: "auto",
                                maxHeight: 400,
                                overflowY: "auto",
                                "&::-webkit-scrollbar": {
                                  width: "7px",
                                  height: "7px",
                                },
                                "&::-webkit-scrollbar-track": {
                                  background: "#f1f1f1",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  background: "#888",
                                  borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                  background: "#555",
                                },
                              }}
                            >
                              <Table size="small" aria-label="a dense table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b></b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Passbook</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Member</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Frequency</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Transactions</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Deposits</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Group</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Community</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Cluster</b>
                                      </Typography>{" "}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {sege_data &&
                                    sege_data?.Customers?.map((row, index) => (
                                      <TableRow
                                        key={row.index}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                          backgroundColor: "#f5f3f4",
                                        }}
                                      >
                                        <TableCell align="left">
                                          <Avatar
                                            sx={{ width: 50, height: 50 }}
                                            src={pic(row.photo)}
                                            alt={row.Member_Name}
                                          />
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            onClick={() =>
                                              handlePsb(
                                                row.Member_id,
                                                row.Member_Name
                                              )
                                            }
                                            sx={{
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Passbook}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.Member_Name}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              {
                                                row.Average_Days_Between_Deposits
                                              }
                                            </b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.Total_Deposits}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              {currencyFormat.format(
                                                row.Total_Savings
                                              )}
                                            </b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            onClick={() =>
                                              visitAssociations(row.Group_id)
                                            }
                                            sx={{
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Savings_Group}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            // onClick={() => visitAssociations(row.Group_id)} sx={{ textDecoration:'underline', cursor:'pointer' }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Community}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            // onClick={() => visitAssociations(row.Group_id)} sx={{ textDecoration:'underline', cursor:'pointer' }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Cluster}</b>
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Grid>
                        </Grid>
                      ) : (
                        <LineManTrendsData
                          title_data={`${who
                            .split(" ")
                            .slice(0, 2)
                            .join(" ")} ${periodic_state} Trend Data`}
                          data={tester?.trend_data}
                        />
                      )}
                    </Grid>
                  </Grid>

                </Ittem>
              </Grid>

            </>
          ) : (
            <Grid item xs={12} md={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Ittem>
                    <Typography
                      variant="h4"
                      sx={{ textAlign: "center" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>{account_data?.account_name} Table</b>
                    </Typography>

                    <Box sx={{ my: 3 }}>
                      <Typography
                        sx={{ textAlign: "center" }}
                        variant="h5"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>
                          {who} {periodic_state} {account_data?.account_name}{" "}
                          Report{" "}
                          <Chip
                            size="small"
                            label={
                              <Typography
                                variant="subtitle"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Export Table</b>
                              </Typography>
                            }
                            sx={{
                              borderRadius: 2,
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor: "#fff9ec",
                              color: "#000",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "darkblue",
                                color: "#fff",
                              },
                            }}
                            onClick={exportToExcel}
                          />
                        </b>
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Chip
                        label={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Weekly Report</b>
                          </Typography>
                        }
                        size="medium"
                        variant={
                          periodic_state === "Weekly" ? "filled" : "outlined"
                        }
                        sx={{
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor:
                            periodic_state === "Weekly" ? "#fff" : "#2b2d42",
                          color: periodic_state === "Weekly" ? "#000" : "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#000",
                          },
                        }}
                        onClick={() => setPeriodicState("Weekly")}
                      />
                      <Chip
                        label={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Monthly Report</b>
                          </Typography>
                        }
                        size="medium"
                        variant={
                          periodic_state === "Monthly" ? "filled" : "outlined"
                        }
                        sx={{
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor:
                            periodic_state === "Monthly" ? "#fff" : "#2b2d42",
                          color: periodic_state === "Monthly" ? "#000" : "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#000",
                          },
                        }}
                        onClick={() => setPeriodicState("Monthly")}
                      />
                      <Chip
                        label={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Quarterly Report</b>
                          </Typography>
                        }
                        size="medium"
                        variant={
                          periodic_state === "Quarterly" ? "filled" : "outlined"
                        }
                        sx={{
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor:
                            periodic_state === "Quarterly" ? "#fff" : "#2b2d42",
                          color:
                            periodic_state === "Quarterly" ? "#000" : "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#000",
                          },
                        }}
                        onClick={() => setPeriodicState("Quarterly")}
                      />
                      <Chip
                        label={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Yearly Report</b>
                          </Typography>
                        }
                        size="medium"
                        variant={
                          periodic_state === "Yearly" ? "filled" : "outlined"
                        }
                        sx={{
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor:
                            periodic_state === "Yearly" ? "#fff" : "#2b2d42",
                          color: periodic_state === "Yearly" ? "#000" : "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                            color: "#000",
                          },
                        }}
                        onClick={() => setPeriodicState("Yearly")}
                      />
                    </Box>
                    <Box
                      sx={{
                        overflowX: "auto",
                        maxHeight: 340,
                        overflowY: "auto",
                        "&::-webkit-scrollbar": {
                          width: "7px",
                          height: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#555",
                        },
                      }}
                    >
                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Date</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Cash Deposits</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Cash Withdrawals</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>
                                  Balance (cash deposits - cash withdrawals)
                                </b>
                              </Typography>{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tester &&
                            tester?.transactions_amount
                              ?.slice()
                              .reverse()
                              .map((row, index) => (
                                <TableRow
                                  key={row.index}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                    backgroundColor: "#f5f3f4",
                                  }}
                                >
                                  <TableCell align="left">
                                    {row.date ===
                                      tester?.top_activity_days?.max_deposit_day
                                        ?.date ||
                                    row.date ===
                                      tester?.top_activity_days
                                        ?.max_withdrawal_day?.date ? (
                                      <Tooltip
                                        title={
                                          row.date ===
                                          tester?.top_activity_days
                                            ?.max_deposit_day?.date
                                            ? "Max Deposits Date"
                                            : "Max Withdrawals Date"
                                        }
                                      >
                                        <Typography
                                          sx={{
                                            color:
                                              row.date ===
                                                tester?.top_activity_days
                                                  ?.max_deposit_day?.date ||
                                              row.date ===
                                                tester?.top_activity_days
                                                  ?.max_withdrawal_day?.date
                                                ? "green"
                                                : "black",
                                          }}
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>
                                            {formatDateToYearMonthDay(
                                              new Date(row.date)
                                            )}
                                          </b>
                                        </Typography>
                                      </Tooltip>
                                    ) : (
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>
                                          {formatDateToYearMonthDay(
                                            new Date(row.date)
                                          )}
                                        </b>
                                      </Typography>
                                    )}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <Box display="flex" alignItems="center">
                                        <b>
                                          {currencyFormat.format(
                                            row.deposit_amount
                                          )}
                                        </b>
                                        <span style={{ marginLeft: "8px" }}>
                                          {row.movement === "Up" ? (
                                            <ArrowUpwardRoundedIcon
                                              sx={{ color: "#007200" }}
                                            />
                                          ) : row.movement === "Down" ? (
                                            <ArrowDownwardRoundedIcon
                                              sx={{ color: "#ff0000" }}
                                            />
                                          ) : (
                                            <BalanceRoundedIcon
                                              sx={{ color: "#03045e" }}
                                            />
                                          )}
                                        </span>
                                      </Box>
                                      <Box
                                        sx={{
                                          color:
                                            row.movement === "Normal"
                                              ? "#03045e"
                                              : row.movement === "Up"
                                              ? "#007200"
                                              : "#ff0000",
                                        }}
                                      >
                                        <Typography
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          variant="caption"
                                          fontSize="0.8em"
                                        >
                                          <b>{row.performance}</b>
                                        </Typography>
                                      </Box>
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <Box display="flex" alignItems="center">
                                        <b>
                                          {currencyFormat.format(
                                            row.withdrawal_amount
                                          )}
                                        </b>
                                      </Box>
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>
                                        {currencyFormat.format(
                                          row.balance_amount
                                        )}
                                      </b>
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </Ittem>
                </Grid>

                <Grid item xs={12} md={12}>
                <Ittem>
                  <Typography
                    variant="h4"
                    sx={{ textAlign: "center" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>{account_data?.account_name} Table Analytics</b>
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                      <Ittem>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Average Metrics</b>
                        </Typography>
                        <Divider />
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Average Deposits:{" "}
                              <span style={{ color: "darkblue" }}>
                                {currencyFormat.format(
                                  tester?.average_metrics?.average_deposit
                                )}
                              </span>
                            </b>
                          </p>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Average Withdrawals:{" "}
                              <span style={{ color: "darkblue" }}>
                                {currencyFormat.format(
                                  tester?.average_metrics?.average_withdrawal
                                )}
                              </span>
                            </b>
                          </p>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <p>
                            <b>
                              Total No. of Members:{" "}
                              <span style={{ color: "darkblue" }}>
                                {
                                  tester?.customer_segments_big_money
                                    ?.unique_depositors
                                }
                              </span>
                            </b>
                          </p>
                        </Typography>
                      </Ittem>
                    </Grid>

                    <Grid item xs={12} md={2}>
                      <Ittem>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Accounts Segmentation</b>
                          </Typography>
                          <Typography
                            variant="caption"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Click on Segment for more Data</b>
                          </Typography>
                          <Divider />
                          <Box sx={{ mr: 2 }}>
                            <SegmentationDonut
                              data={
                                tester?.customer_segments?.customer_segments
                              }
                              setSege={setSege}
                              setSege_data={setSege_data}
                              sege_who={sege_who}
                              setSege_who={setSege_who}
                            />
                          </Box>
                        </Box>
                      </Ittem>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          View:
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Clusters</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Clusters" ? "filled" : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Clusters" ? "#fff" : "#2b2d42",
                              color:
                                sege_level === "Clusters" ? "#000" : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Clusters")}
                          />
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Communities</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Communities"
                                ? "filled"
                                : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Communities"
                                  ? "#fff"
                                  : "#2b2d42",
                              color:
                                sege_level === "Communities" ? "#000" : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Communities")}
                          />
                          <Chip
                            label={
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Saving Groups</b>
                              </Typography>
                            }
                            size="medium"
                            variant={
                              sege_level === "Saving Groups"
                                ? "filled"
                                : "outlined"
                            }
                            sx={{
                              m: 1,
                              boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                              backgroundColor:
                                sege_level === "Saving Groups"
                                  ? "#fff"
                                  : "#2b2d42",
                              color:
                                sege_level === "Saving Groups"
                                  ? "#000"
                                  : "#fff",
                              "&:hover": {
                                boxShadow:
                                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                                color: "#000",
                              },
                            }}
                            onClick={() => setSege_level("Saving Groups")}
                          />
                        </b>
                      </Typography>
                      <SegmentBars
                        title_data={`${account_data?.account_name} ${sege_level} Accounts Segments`}
                        data={
                          sege_level === "Clusters"
                            ? tester?.customer_segments?.cluster_segments
                            : sege_level === "Communities"
                            ? tester?.customer_segments?.community_segments
                            : tester?.customer_segments?.association_segments
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={2}>
                          <Ittem>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>
                                  Accounts Segmentation (Based on Deposits
                                  Value)
                                </b>
                              </Typography>
                              <Typography
                                variant="caption"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Click on Segment for more Data</b>
                              </Typography>
                              <Divider />
                              <Box sx={{ mr: 2 }}>
                                <SegmentationDonutCash
                                  data={
                                    tester?.customer_segments_big_money
                                      ?.customer_segments
                                  }
                                  setSege={setSege}
                                  setSege_data={setSege_data}
                                  sege_who={sege_who}
                                  setSege_who={setSege_who}
                                />
                              </Box>
                            </Box>
                          </Ittem>
                        </Grid>

                        <Grid item xs={12} md={10}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              View:
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Clusters</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Clusters"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Clusters"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Clusters" ? "#000" : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Clusters")}
                              />
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Communities</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Communities"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Communities"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Communities"
                                      ? "#000"
                                      : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Communities")}
                              />
                              <Chip
                                label={
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Saving Groups</b>
                                  </Typography>
                                }
                                size="medium"
                                variant={
                                  sege_level === "Saving Groups"
                                    ? "filled"
                                    : "outlined"
                                }
                                sx={{
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor:
                                    sege_level === "Saving Groups"
                                      ? "#fff"
                                      : "#2b2d42",
                                  color:
                                    sege_level === "Saving Groups"
                                      ? "#000"
                                      : "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#000",
                                  },
                                }}
                                onClick={() => setSege_level("Saving Groups")}
                              />
                            </b>
                          </Typography>
                          <SegmentBarsDep
                            title_data={`${account_data?.account_name} ${sege_level} Accounts Segments (Deposits Value)`}
                            data={
                              sege_level === "Clusters"
                                ? tester?.customer_segments_big_money
                                    ?.cluster_segments
                                : sege_level === "Communities"
                                ? tester?.customer_segments_big_money
                                    ?.community_segments
                                : tester?.customer_segments_big_money
                                    ?.association_segments
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      {sege ? (
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            sx={{ display: "flex", flexDirection: "row" }}
                          >
                            <IconButton
                              sx={{ mr: "auto" }}
                              onClick={() => setSege(false)}
                            >
                              <ArrowBackRoundedIcon />
                            </IconButton>
                            <Typography
                              variant="h4"
                              sx={{ mr: "auto" }}
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>{sege_who}</b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Transaction: {sege_data?.Total_Deposits}{" "}
                                transactions
                              </b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Deposits:{" "}
                                {currencyFormat.format(
                                  sege_data?.Total_Savings
                                )}
                              </b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Total Members: {sege_data?.Customers.length}
                              </b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Saving Groups: {associationCount}</b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Communities: {communityCount}</b>
                            </Typography>
                            <Typography
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Total Clusters: {clusterCount}</b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <Box
                              sx={{
                                overflowX: "auto",
                                maxHeight: 400,
                                overflowY: "auto",
                                "&::-webkit-scrollbar": {
                                  width: "7px",
                                  height: "7px",
                                },
                                "&::-webkit-scrollbar-track": {
                                  background: "#f1f1f1",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  background: "#888",
                                  borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                  background: "#555",
                                },
                              }}
                            >
                              <Table size="small" aria-label="a dense table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b></b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Passbook</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Member</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Frequency</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Transactions</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Deposits</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Group</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Community</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Cluster</b>
                                      </Typography>{" "}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {sege_data &&
                                    sege_data?.Customers?.map((row, index) => (
                                      <TableRow
                                        key={row.index}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                          backgroundColor: "#f5f3f4",
                                        }}
                                      >
                                        <TableCell align="left">
                                          <Avatar
                                            sx={{ width: 50, height: 50 }}
                                            src={pic(row.photo)}
                                            alt={row.Member_Name}
                                          />
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            onClick={() =>
                                              handlePsb(
                                                row.Member_id,
                                                row.Member_Name
                                              )
                                            }
                                            sx={{
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Passbook}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.Member_Name}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              {
                                                row.Average_Days_Between_Deposits
                                              }
                                            </b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.Total_Deposits}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              {currencyFormat.format(
                                                row.Total_Savings
                                              )}
                                            </b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            onClick={() =>
                                              visitAssociations(row.Group_id)
                                            }
                                            sx={{
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Savings_Group}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            // onClick={() => visitAssociations(row.Group_id)} sx={{ textDecoration:'underline', cursor:'pointer' }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Community}</b>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography
                                            // onClick={() => visitAssociations(row.Group_id)} sx={{ textDecoration:'underline', cursor:'pointer' }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{row.Cluster}</b>
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Grid>
                        </Grid>
                      ) : (
                        <LineManTrendsData
                          title_data={`${who
                            .split(" ")
                            .slice(0, 2)
                            .join(" ")} ${periodic_state} Trend Data`}
                          data={tester?.trend_data}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Ittem>
              </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12} md={4}>
            <Item>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Typography
                    sx={{ marginRight: "auto" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Current Amount</b>
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={4}
                  sx={{ display: "flex", flexDirection: "row" }}
                >
                  <Typography
                    sx={{ margin: "auto", color: "#2b2d42" }}
                    variant="h3"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b style={{ marginRight: "5px" }}>
                      {currencyFormat.format(details.total_current_balance)}
                    </b>
                    {/* {members.members_this_month > 0 ? (<TrendingUpIcon color="success"/>) : null} */}
                  </Typography>
                </Grid>
              </Grid>
            </Item>

            <Item>
              <PieGuyAssociation
                title_data={account_data?.account_name}
                associations={details?.associations}
              />
            </Item>
          </Grid>

          <Grid item xs={12} md={8}>
            <Item>
              <BarGuyAssociation
                title_data={account_data?.account_name}
                associations={details?.associations}
              />
            </Item>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12}>
          <Item>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                variant="fullWidth"
                value={value1}
                onChange={handleChange1}
                aria-label="basic tabs example"
              >
                <Tab
                  label={
                    <b
                      style={{
                        color: "Blue",
                        fontStyle: "normal",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Daily
                    </b>
                  }
                  {...a11yProps(0)}
                />
                <Tab
                  label={
                    <b
                      style={{
                        color: "darkred",
                        fontStyle: "normal",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Weekly
                    </b>
                  }
                  {...a11yProps(1)}
                />
                <Tab
                  label={
                    <b
                      style={{
                        color: "brown",
                        fontStyle: "normal",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Monthly
                    </b>
                  }
                  {...a11yProps(2)}
                />
                <Tab
                  label={
                    <b
                      style={{
                        color: "indigo",
                        fontStyle: "normal",
                        fontFamily:
                          "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
                      }}
                    >
                      Yearly
                    </b>
                  }
                  {...a11yProps(3)}
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value1} index={0}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <AreaManSavings
                    title_data={account_data?.account_name}
                    data={details?.daily_transactions_amount}
                    time={"Daily"}
                  />
                </Grid>
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value1} index={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <AreaManSavings
                    title_data={account_data?.account_name}
                    data={details?.weekly_transactions_amount}
                    time={"Weekly"}
                  />
                </Grid>
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value1} index={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <AreaManSavings
                    title_data={account_data?.account_name}
                    data={details?.monthly_transactions_amount}
                    time={"Monthly"}
                  />
                </Grid>
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value1} index={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <AreaManSavings
                    title_data={account_data?.account_name}
                    data={details?.yearly_transactions_amount}
                    time={"Yearly"}
                  />
                </Grid>
              </Grid>
            </CustomTabPanel>
          </Item>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Box sx={{ m: "auto", mt: 20, p: "auto" }}>
        <Typography
          sx={{ margin: "auto", textAlign: "center" }}
          variant="h3"
          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        >
          <b>
            Choose Society To View It's {account_data?.account_name} Details
          </b>
        </Typography>
      </Box>
    );
  }
};
